/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Delete_ConfirmInputs */

const en_us2_coach_manage_delete_confirm = /** @type {(inputs: Coach_Manage_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete conversation`)
};

const pt_br2_coach_manage_delete_confirm = /** @type {(inputs: Coach_Manage_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar conversa`)
};

const es_419_coach_manage_delete_confirm = /** @type {(inputs: Coach_Manage_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar conversación`)
};

const pt_pt2_coach_manage_delete_confirm = /** @type {(inputs: Coach_Manage_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar conversa`)
};

const fr_fr2_coach_manage_delete_confirm = /** @type {(inputs: Coach_Manage_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_de2_coach_manage_delete_confirm = /** @type {(inputs: Coach_Manage_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung löschen`)
};

const it_it2_coach_manage_delete_confirm = /** @type {(inputs: Coach_Manage_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina conversazione`)
};

/**
* | output |
* | --- |
* | "Delete conversation" |
*
* @param {Coach_Manage_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_delete_confirm = /** @type {((inputs?: Coach_Manage_Delete_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Delete_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_delete_confirm(inputs)
	if (locale === "es-419") return es_419_coach_manage_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_delete_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_delete_confirm(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_delete_confirm(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_delete_confirm(inputs)
	return en_us2_coach_manage_delete_confirm(inputs)
});
export { coach_manage_delete_confirm as "coach-manage.delete_confirm" }